// Утилита для настройки PDF worker'а с fallback механизмом
export function setupPdfWorker(pdfjs: any) {
    // Проверяем, не настроен ли уже worker
    if (pdfjs.GlobalWorkerOptions.workerSrc && pdfjs.GlobalWorkerOptions.workerSrc !== '') {
        console.log('✅ PDF worker уже настроен:', pdfjs.GlobalWorkerOptions.workerSrc);
        return {
            handleWorkerError: () => {},
            setNextWorkerUrl: () => false,
            getCurrentWorkerUrl: () => pdfjs.GlobalWorkerOptions.workerSrc
        };
    }

    // Список альтернативных CDN для fallback (в порядке приоритета)
    const cdnUrls = [
        '/pdf.worker.min.js', // Локальный файл (основной)
        'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js', // unpkg CDN
        'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js', // jsDelivr CDN
        'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js' // Cloudflare CDN (последний fallback)
    ];

    // Проверяем localStorage для сохранения рабочего URL
    const savedWorkerUrl = localStorage.getItem('pdfWorkerUrl');
    let currentUrlIndex = 0;

    // Если есть сохраненный URL, начинаем с него
    if (savedWorkerUrl && cdnUrls.includes(savedWorkerUrl)) {
        currentUrlIndex = cdnUrls.indexOf(savedWorkerUrl);
        console.log(`🔄 Восстанавливаем сохраненный worker: ${savedWorkerUrl}`);
    }

    // Функция для установки следующего URL в списке
    function setNextWorkerUrl() {
        if (currentUrlIndex < cdnUrls.length) {
            const url = cdnUrls[currentUrlIndex];
            pdfjs.GlobalWorkerOptions.workerSrc = url;
            // Сохраняем текущий URL в localStorage
            localStorage.setItem('pdfWorkerUrl', url);
            console.log(`🔄 Пробуем PDF worker с: ${url}`);
            currentUrlIndex++;
            return true;
        }
        return false;
    }

    // Функция для обработки ошибок загрузки worker'а
    function handleWorkerError(error: any) {
        console.warn(`❌ Ошибка загрузки worker с ${pdfjs.GlobalWorkerOptions.workerSrc}:`, error);
        
        // Удаляем неработающий URL из localStorage
        localStorage.removeItem('pdfWorkerUrl');
        
        if (setNextWorkerUrl()) {
            console.log('🔄 Переключаемся на следующий источник...');
        } else {
            console.error('💥 Все источники PDF worker исчерпаны!');
        }
    }

    // Начинаем с текущего индекса
    setNextWorkerUrl();
    console.log('✅ PDF worker настроен с fallback механизмом');
    
    // Возвращаем функцию для обработки ошибок, которую можно использовать в компонентах
    return {
        handleWorkerError,
        setNextWorkerUrl,
        getCurrentWorkerUrl: () => pdfjs.GlobalWorkerOptions.workerSrc,
        resetWorkerUrl: () => {
            localStorage.removeItem('pdfWorkerUrl');
            console.log('🔄 Сброшен сохраненный worker URL');
        }
    };
}

// Тестовая функция для проверки fallback механизма
export function testPdfWorkerFallback() {
    console.log('🧪 Тестирование fallback механизма PDF worker...');
    
    const testUrls = [
        '/pdf.worker.min.js',
        'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js',
        'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js'
    ];
    
    console.log('📋 Список источников:');
    testUrls.forEach((url, index) => {
        console.log(`${index + 1}. ${url}`);
    });
    
    const savedUrl = localStorage.getItem('pdfWorkerUrl');
    if (savedUrl) {
        console.log(`💾 Сохраненный URL: ${savedUrl}`);
    } else {
        console.log('💾 Сохраненный URL: нет');
    }
    
    console.log('✅ Тест завершен. Проверьте консоль при загрузке PDF.');
} 